import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { Alert, Button, Col, Form, Input, Statistic, Table, Typography } from 'antd'
import CountrySelect from 'elements/Select/Country'
import { defaultFormItemLayout, rules } from 'modules/FormItems'
import React, { useState } from 'react'
import { get, round } from 'lodash'
import Auth from '../../modules/Authentication'
import { apiUrl } from '../../variables'

const auth = new Auth()
const { Title } = Typography

const CARD_OPTIONS = {
  iconStyle: 'solid',
  style: {
    base: {
      fontWeight: 500,
      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
    },
  },
}

const CheckoutForm = (props) => {
  const { setSucceeded, currency, description, amount, postURL, payload, onCancel } = props
  const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = props.form

  const { lines = [{}], columns, lineTitle } = payload
  const amountInCents = Math.floor(amount * 100)
  const stripe = useStripe()
  const element = useElements()
  const [error, setError] = useState(null)
  const [processing, setProcessing] = useState(false)

  function checkForm() {
    return new Promise((res, rej) => {
      props.form.validateFields((err, values) => {
        if (!err) {
          res(values)
        } else {
          setProcessing(false)
        }
      })
    })
  }

  const onSubmit = async (event) => {
    event.preventDefault()
    setProcessing(true)

    const values = await checkForm()
    // props.form.validateFields((err, values) => {
    console.log({ values })
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: element.getElement(CardElement),
    })

    if (error) {
      setError(`Payment failed: ${error.message}`)
      setProcessing(false)
      console.log(error)
    } else {
      const { id } = paymentMethod
      try {
        const response = await fetch('https://payment.mondiale.com/api/create-payment-intent', {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify({
            id,
            currency,
            description,
            amount: amountInCents,
          }),
        })
        const data = await response.json()
        console.log(data)

        if (data.status === 'succeeded') {
          const pmsResponse = await fetch(`${apiUrl}${postURL}`, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              authorization: `Bearer ${auth.getAccessToken()}`,
            },
            method: 'POST',
            body: JSON.stringify({
              currency,
              description,
              amount,
              ...values,
              ...payload,
              stripeTransaction: data,
            }),
          })
          const pmsData = await pmsResponse.json()

          if (pmsResponse.status >= 200 && pmsResponse.status < 300) {
            setSucceeded({ pmsData, data })
            setError(null)
            setProcessing(false)
            console.log(pmsData)
          } else {
            throw await response.json()
          }
        } else {
          setError(get(data, 'raw.message', 'Card Declined'))
          setSucceeded(false)
          setProcessing(false)
        }
      } catch (e) {
        setError(get(e, 'message', 'Error Happened'))
        setSucceeded(false)
        setProcessing(false)
        console.log(e)
      }
    }
    // })
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  }
  return (
    <Form {...formItemLayout} onSubmit={onSubmit}>
      <div className="flex flex-col space-y-5 mt-5">
        {lines.length > 0 && (
          <div>
            <Title level={4}>{lineTitle}</Title>
            <Table columns={columns} dataSource={lines} />
          </div>
        )}

        <Statistic title="Amount Payable is" value={round(amount, 2)} prefix={currency} />

        {error && <Alert style={{ margin: 20 }} message="Error" description={error} type="error" showIcon />}

        <Title level={4}>Card Details</Title>

        <Form.Item label="Name On Card">
          {getFieldDecorator('name', { rules: rules.input })(<Input placeholder={'Name On Card'} />)}
        </Form.Item>

        <Title level={3}>Billing Address</Title>

        <Form.Item label="Address">
          {getFieldDecorator('address1', { rules: rules.input })(<Input placeholder={'Address Line 1'} />)}
          {getFieldDecorator('address2',
            //{ rules: rules.input }
            )(<Input placeholder={'Address Line 2'} />)}
        </Form.Item>

        <Form.Item label="City">
          {getFieldDecorator('city',
            //{ rules: rules.input }
          )(<Input placeholder={'City'} />)}
        </Form.Item>

        <Form.Item label="State">
          {getFieldDecorator('state',
            //{ rules: rules.input }
            )(<Input placeholder={'State'} />)}
        </Form.Item>

        <Form.Item label="Postal Code">
          {getFieldDecorator('postalCode', { rules: rules.input })(<Input placeholder={'Postal Code'} />)}
        </Form.Item>

        <Form.Item label="Country">{getFieldDecorator('country', { rules: rules.input })(<CountrySelect />)}</Form.Item>

        <CardElement options={CARD_OPTIONS} />
      </div>

      <div className="mt-5 space-x-2">
        <Button type="primary" htmlType="submit" loading={processing} disabled={!stripe}>
          {processing ? 'Processing…' : ' Pay Now'}
        </Button>

        <Button onClick={onCancel}>Exit</Button>
      </div>
    </Form>
  )
}

export default Form.create()(CheckoutForm)
